import React from 'react';
import { Button } from './ui/button';
import { MapPin, Clock, Shield, Heart } from 'lucide-react';
import { practiceInfo } from '../data/mock';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-red-50 via-white to-red-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Gemeinsam für Ihre
            <span className="text-red-600 block">Gesundheit</span>
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            {practiceInfo.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              size="lg"
              className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-8 py-4 text-lg"
              onClick={() => window.open(practiceInfo.contact.booking_url, '_blank')}
            >
              Online Termin buchen
            </Button>
            <Button 
              size="lg"
              variant="outline"
              className="border-red-300 text-red-700 hover:bg-red-50 px-8 py-4 text-lg"
              onClick={() => document.getElementById('kontakt').scrollIntoView({ behavior: 'smooth' })}
            >
              Kontakt aufnehmen
            </Button>
          </div>

          {/* Quick Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mx-auto mb-4">
                <MapPin className="h-6 w-6 text-red-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Zentral gelegen</h3>
              <p className="text-gray-600 text-sm">
                {practiceInfo.address.street}<br />
                {practiceInfo.address.city}
              </p>
            </div>

            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mx-auto mb-4">
                <Clock className="h-6 w-6 text-red-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Flexible Termine</h3>
              <p className="text-gray-600 text-sm">
                Auch Notfallsprechstunden<br />
                Montag–Freitag verfügbar
              </p>
            </div>

            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mx-auto mb-4">
                <Heart className="h-6 w-6 text-red-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Erfahrenes Team</h3>
              <p className="text-gray-600 text-sm">
                Über 15 Jahre Erfahrung<br />
                in der Frauenheilkunde
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;